import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import PuenteScreen from '@src/screens/PuenteScreen';
import NotFound from '@src/screens/NotFound';
import { esperarCanalDeApp, tieneCanalDeApp } from '@src/shared/utils/appBridge';
import { detectarModo, ModoPagina } from '@src/shared/utils/consent';
import ContratoApp from './ContratoApp';
import EstacionFirma from './EstacionFirma';

/**
 * `/consent/:id` — dentro de la app, el contrato de la clienta (`ContratoApp`); con el QR que el
 * Punto de Venta le muestra, la estación de firma (`EstacionFirma`); en cualquier otro lado, la
 * página puente (decisión de Irving del 7/oct/2026).
 */
const ConsentScreen: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { search } = useLocation();
    const [modo, setModo] = useState<ModoPagina | null>(null);

    useEffect(() => {
        let vigente = true;
        const pideApp = new URLSearchParams(search).get('app') === '1';
        (pideApp ? esperarCanalDeApp() : Promise.resolve(tieneCanalDeApp())).then((canal) => {
            if (vigente) setModo(detectarModo(search, canal));
        });
        return () => {
            vigente = false;
        };
    }, [search]);

    if (!id) return <NotFound />;
    if (!modo) {
        return (
            <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '60vh' }}>
                <CircularProgress size={28} />
            </Stack>
        );
    }
    if (modo.modo === 'puente') return <PuenteScreen recurso="consent" />;
    if (modo.modo === 'app') return <ContratoApp id={id} />;
    return <EstacionFirma id={id} modo={modo} />;
};

export default ConsentScreen;
